<template>
  <div class="container">
    <h2 class="text-center title"> {{ $t('home.about_us.title') }}</h2>
  <p class="text-center description">{{ $t('home.about_us.description') }}
  </p>
  
  <div class="row main-row">
    <!-- Text Content -->
    <div class="col-lg-6 col-12 text-content-container">
      <h6 class="section-title">
        <img src="@/assets/images/home/aboutus/point.png" class="point-img" />
        {{ $t('home.about_us.vision') }}
      </h6>
      <p class="content">
        {{ $t('home.about_us.vision_paragraph') }}
      </p>
      
      <h6 class="section-title">
        <img src="@/assets/images/home/aboutus/point.png" class="point-img" />
        {{ $t('home.about_us.message') }}
      </h6>
      <p class="content">
        {{ $t('home.about_us.message_paragraph') }}
      </p>
      <button class="btn btn-primary"> {{  $t('home.about_us.read_more') }}</button>
    </div>

    <!-- Image Content -->
    <div class="col-lg-6 col-12 d-none d-lg-block">
      <div class="row">
        <div class="col-lg-6 col-12">
          <div class="image-box">
            <img src="@/assets/images/home/aboutus/image3.png" class="img1" />
          </div>
        </div>
        <div class="col-lg-6 col-12">
          <div class="image-box">
            <img src="@/assets/images/home/aboutus/image1.png" class="img2" />
          </div>
          <div class="image-box">
            <img src="@/assets/images/home/aboutus/image2.png" class="img2" />
          </div>
        </div>
      </div>
    </div>
  </div>
  </div>
  
</template>

<style scoped>
.container {
  margin-top: 40px;
}
/* General Text Styles */
.title {
  font-size: 36px;
  font-weight: 500;
}

.description {
  font-size: 18px;
  font-weight: 400;
  margin-top: 25px;
}

h6.section-title {
  font-size: 28px;
  font-weight: 500;
  margin-bottom: 21px;
}

.content {
  margin-bottom: 24px;
}

.btn {
  width: 156px;
  height: 56px;
  border-radius: 12px;
  font-size: 20px;
  font-weight: 500;
  margin-top: 20px;
}

/* Layout Styling */
.main-row {
  margin-top: 40px;
}

.text-content-container {
  padding-top: 50px;
}

.image-box {
  border-radius: 20px;
  overflow: hidden;
  margin-bottom: 20px;
}

/* Point Icon Styling */
.point-img {
  width: 20px;
  height: 24px;
  margin-inline-end: 10px; /* Adjusted for better spacing */
}

/* Image Styling */
.img1 {
  width: 100%;
  height: 486px;
  object-fit: cover; /* Ensures the image covers the container while maintaining aspect ratio */
}

.img2 {
  width: 100%;
  height: 231px;
  object-fit: cover; /* Ensures the image covers the container while maintaining aspect ratio */
}
</style>
